import { sprintf } from 'sprintf-js';
import { BmUIKitConfig } from './config.js';

const __ = BmUIKitConfig.getOption("__");
const __sprintf = (text, ...args)=>sprintf(__(text), args);

export { __, __sprintf };
//# sourceMappingURL=i18n.js.map
